import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";

import { useAuth } from "context/AuthContext";
import { useCurrency } from "context/CurrencyContext";
import MobileTopBar from "mobile/components/MobileTopBar";

export default function SettingsMobile() {
  const navigate = useNavigate();
  const { user, pluginRole } = useAuth();
  const { currency } = useCurrency();

  const username = useMemo(() => {
    const u = user?.username || user?.email || user?.name || null;
    return u ? String(u) : "—";
  }, [user]);

  return (
    <Box sx={{ px: 1, pb: 2 }}>
      <MobileTopBar title="Settings" subtitle="Preferences" onBack={() => navigate("/m/dashboard")} />

      <Stack spacing={0.75} sx={{ mt: 1 }}>
        <Card variant="outlined">
          <Box sx={{ p: 1 }}>
            <Typography variant="subtitle2" fontWeight={900} sx={{ mb: 0.75 }}>
              Account
            </Typography>
            <Stack spacing={0.5}>
              <Typography variant="body2" fontWeight={800}>
                {username}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Role: {String(pluginRole || "—")}
              </Typography>
            </Stack>
          </Box>
        </Card>

        <Card variant="outlined">
          <Box sx={{ p: 1 }}>
            <Typography variant="subtitle2" fontWeight={900} sx={{ mb: 0.75 }}>
              Currency
            </Typography>
            <Typography variant="body2" fontWeight={800}>
              Company currency (fixed): {currency || "USD"}
            </Typography>
          </Box>
        </Card>

        <Card variant="outlined">
          <Box sx={{ p: 1 }}>
            <Typography variant="subtitle2" fontWeight={900} sx={{ mb: 0.75 }}>
              Session
            </Typography>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="body2" fontWeight={800}>
                Sign out
              </Typography>
              <IconButton aria-label="Sign out" onClick={() => navigate("/m/sign-out")}>
                <Icon fontSize="small">logout</Icon>
              </IconButton>
            </Stack>
          </Box>
        </Card>
      </Stack>
    </Box>
  );
}
